import React from 'react';
import { Spin } from 'antd';
import '../style/loader.css';

function Loader({ size = 'large', tip = 'Loading...', className = '' }) {
    return (
        <div className={`loader-container ${className}`}>
            <Spin size={size} tip={tip} />
        </div>
    );
}

export default Loader;